import classnames from 'classnames'
import * as React from 'react'
import { formatImageUrl } from 'embed/utils'
import { LoanOffer } from 'embed/constants/models'

const styles = require('embed/styles/results')

interface PartnerLogoProps {
  dispatchOfferCta?: (loan: LoanOffer) => void
  handleLoanOfferCtaClick: (event: React.MouseEvent<Element>) => void
  offer: LoanOffer
  offerStyleIsCompact: boolean
}

export const PartnerLogo: React.FC<PartnerLogoProps> = ({
  dispatchOfferCta,
  handleLoanOfferCtaClick,
  offer,
  offerStyleIsCompact,
}) => {
  const partnerLogoClassName = classnames(styles.partnerImage, { [styles.partnerImageSmall]: offerStyleIsCompact })
  return dispatchOfferCta !== undefined ? (
    <a className={styles.partnerLogoLink} onClick={handleLoanOfferCtaClick}>
      <img
        className={partnerLogoClassName}
        alt={offer?.originator?.name ?? ''}
        src={formatImageUrl(offer?.originator?.images?.[0]?.url ?? '')}
      />
    </a>
  ) : (
    <img
      className={partnerLogoClassName}
      alt={offer?.originator?.name ?? ''}
      src={formatImageUrl(offer?.originator?.images?.[0]?.url ?? '')}
    />
  )
}
